import { useState, useCallback, useMemo } from 'react'
import { useSubscription } from 'streamr-client-react'
import useIsMounted from '~hooks/useIsMounted'

const DATA_HISTORY_STREAM_ID = '0x7c56a3197f4277dcf08881a7988f3150d1f87510/DATA-historical-price'

export default function useHistoricalDataTokenStream() {
    const isMounted = useIsMounted()

    const [today, setTodayPoints] = useState([])
    const [week, setWeekPoints] = useState([])
    const [month, setMonthPoints] = useState([])
    const [year, setYearPoints] = useState([])
    const [all, setAllPoints] = useState([])

    const onHistoryMessage = useCallback(({
        todayPoints,
        weekPoints,
        monthPoints,
        yearPoints,
        allPoints,
    }) => {
        if (isMounted()) {
            setTodayPoints(todayPoints)
            setWeekPoints(weekPoints)
            setMonthPoints(monthPoints)
            setYearPoints(yearPoints)
            setAllPoints(allPoints)
        }
    }, [isMounted])

    useSubscription({
        stream: DATA_HISTORY_STREAM_ID,
        resend: {
            last: 1,
        },
    }, {
        onMessage: onHistoryMessage,
    })

    return useMemo(() => ({
        today,
        week,
        month,
        year,
        all,
    }), [
        today,
        week,
        month,
        year,
        all,
    ])
}
